import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  type BulkEditLocationsDataModalContainerProps,
  BulkEditLocationsModalContainer,
} from './bulkEditLocationsModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BulkEditLocationsData: BulkEditLocationsDataModalContainerProps;
  }
}
modalRenderer.register('BulkEditLocationsData', BulkEditLocationsModalContainer);
